<script>

import TheMeetingScholarshipParameterForm from "../../Form/TheMeetingScholarshipParameterForm.vue";
import {mapActions, mapMutations, mapState} from "vuex";
import _ from "lodash";
export default {
  name: "TheMeetingEditParamsDialog",

  props: {
    visible: Boolean,
  },

  components: {
    TheMeetingScholarshipParameterForm
  },

  data() {
    return {
      loading: false,
    };
  },

  computed: {

    ...mapState({
      payloadStore: state => state.scholarship_meeting.payload,
      meeting: state => state.scholarship_meeting.meeting,
    }),

    show: {
      get() {
        return this.visible;
      },

      set(value) {
        if (!value) {
          this.$emit('close')
        } else {
          this.payload = this.payloadStore;
        }
      }
    },
  },

  methods: {
    ...mapMutations({
      resetPayloadMeeting: 'scholarship_meeting/resetPayloadMeeting',
    }),

    ...mapActions({
      updateMeeting: 'scholarship_meeting/updateMeeting',
    }),

    closeDialog() {
      this.show = false;
      this.resetPayloadMeeting();
    },

    async updatingMeeting() {
      if (this.$refs.editMeetingForm.validate()) {
        this.loading = true;
        try {
          await this.updateMeeting(this.formattingPayloadToServer());
          this.closeDialog();
        } catch(err) {
          console.log(err)
        }
        this.loading = false;
      }
    },

    formattingPayloadToServer() {
      const payload = _.cloneDeep(this.payloadStore)
      return  {
        chairman: _.get(payload, ['chairman', 'id'], null),
        secretary: _.get(payload, ['secretary', 'id'], null),
        meeting_date: _.get(payload, ['meeting_date'], null),
        number_seats_available: _.get(payload, ['number_seats_available'], null),
        student_chairman_asset: _.get(payload, ['student_chairman_asset', 'id'], null),
        listeners: _.map(payload.listeners, (listener) => _.get(listener, ['id'])),
      }
    },

  },
}
</script>

<template>
  <v-dialog
    :value="show"
    persistent
    width="650px"
    content-class="rounded-xl"
  >
    <v-sheet class="rounded-xl">
      <v-card-title>
        Редактирование параметров
        <v-spacer/>
        <v-btn
          @click="closeDialog"
          icon
        >
          <v-icon>fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider/>
      <v-card-text>
        <v-form :disabled="!meeting.access_current_meeting" class="my-2" ref="editMeetingForm">
          <the-meeting-scholarship-parameter-form
            :dialog="show"
          />
        </v-form>
      </v-card-text>

      <v-divider/>

      <v-card-actions>
        <v-spacer/>
        <v-btn
          class="rounded-xl white--text"
          color="teal darken-3"
          @click="updatingMeeting"
          :loading="loading"
        >
          Сохранить
        </v-btn>
      </v-card-actions>
    </v-sheet>

  </v-dialog>
</template>

<style scoped>

</style>